const SEGMENTS = {
    SELLER: 'dealers',
};

const VERTICALS = {
    FURNITURE: 'furniture',
    ART: 'art',
    JEWELRY: 'jewelry',
    FASHION: 'fashion',
};

export { SEGMENTS, VERTICALS };
